import { useEffect } from "react";

export default function useOnLoad() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const onLoad = () => {
      const preloader = document.getElementById("preloader");
      if (preloader) {
        preloader.style.display = "none";
      }
    };

    // Check if the document is already loaded
    if (document.readyState === "complete") {
      onLoad();
    } else {
      window.addEventListener("load", onLoad);
    }

    // Cleanup
    return () => {
      window.removeEventListener("load", onLoad);
    };
  }, []);
}
